import React, { useEffect, useState } from 'react';

import { Dialog, DialogContent, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const useStyles = makeStyles((theme) => ({
  content: {
    position: 'relative',
    padding: 0,
    backgroundColor: '#000000',

    '&:first-child': {
      padding: 0
    }
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'rgba(0,0,0,0.4)',
    color: '#fff',
    '&:hover': {
      background: 'rgba(0,0,0,0.6)'
    }
  },
  image: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '80vh',
    margin: 'auto',
    borderRadius: 8
  }
}));

const StudentDialog = ({ open, onClose, urls = [] }) => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, [urls]);

  if (!urls || urls.length === 0) return null;

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % urls.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + urls.length) % urls.length);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogContent className={classes.content}>
        <img
          src={urls[currentIndex]}
          alt={`Preview ${currentIndex + 1} of ${urls.length}`}
          className={classes.image}
        />
        {urls.length > 1 && (
          <IconButton
            onClick={handlePrev}
            className={classes.navButton}
            style={{ left: 8 }}
          >
            <ArrowBackIosIcon />
          </IconButton>
        )}
        {urls.length > 1 && (
          <IconButton
            onClick={handleNext}
            className={classes.navButton}
            style={{ right: 8 }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StudentDialog;
